import styled from 'styled-components'

export const StyledWidgetHeader = styled.div`
  padding: 20px 16px;
  background-color: white;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 50;
  box-shadow: inset 0px -1px 0px #dbe2f3;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  @media screen and (max-width: 992px) {
    margin-bottom: 12px;
  }

  svg {
    height: 30px;
    width: 100px;
    object-fit: contain;
  }
`
export const SvgLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: auto;
  max-width: 194px;

  svg {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
`

export const VerticalDivider = styled.div`
  height: 24px;
  width: 1px;
  background-color: #d1d5db;
`
